import {
  PropsWithChildren,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
} from "react";
import HeaderPayment from "./HeaderPayment";
import TotalCart from "../Cart/TotalCart";
import PaymentContext from "../../store/PaymentContext";
import { useRouter } from "next/router";

type TLayoutProps = PropsWithChildren & {
  className?: string;
  hasFooter?: boolean;
};

const LayoutPayment = ({
  children,
  className,
  hasFooter = true,
}: TLayoutProps) => {
  const { currentStep, setSpinLoading, rentCarts, sellCarts, isMobile } =
    useContext(PaymentContext);
  const router = useRouter();

  let step = 1;
  switch (router.pathname) {
    case "/checkout":
      step = 2;
      break;
    case "/order-success":
      step = 3;
      break;
  }

  const height = () => {
    if (step == 1 && (rentCarts?.length > 0 || sellCarts?.length > 0)) {
      return isMobile ? "7.5rem" : "0rem";
    }

    if (step == 2 && isMobile) {
      return "0rem";
    }

    return "5rem";
  };

  return (
    <main className={className}>
      <HeaderPayment />
      <div
        style={{ height: `calc(100vh - ${height()})` }}
        className='overflow-y-auto'
      >
        {children}
      </div>
      {hasFooter &&
        step == 1 &&
        (rentCarts?.length > 0 || sellCarts?.length > 0) && (
          <TotalCart setLoading={setSpinLoading} />
        )}
    </main>
  );
};

export default LayoutPayment;
